// controllers/share_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    slug: String
  }

  copy() {
    const url = `${window.location.origin}${window.location.pathname}#${this.slugValue}`
    navigator.clipboard.writeText(url)
  }
}